angular
  .module('ui-ng-session-timer')
  .component('userSessionTimer', {
    template:
      '<session-timer wait-time="{{$ctrl.waitTime}}" on-tick="$ctrl.onTick(count)" on-end="$ctrl.warningCallBack()"></session-timer>',
    controller: 'userSessionTimerController',
    bindings: {
      waitTime: '@',
      notificationHandle: '@'
    }
  })
  .controller(
    'userSessionTimerController',
    function userSessionTimerController(
      $scope,
      $modal,
      logoutCommand,
      sessionTimerDelegate,
      $state,
      $timeout,
      phxNotificationDelegate,
      extendSessionCommand
    ) {
      let warningModal;
      const WAIT_TIME_DEFAULT = 180;

      this.$onInit = () => {
        this.countDown;
        this.modal = {
          isModalVisible: false
        };
        this.waitTime = this.waitTime ? this.waitTime : '30m';
        this.notificationHandle = this.notificationHandle ? this.notificationHandle : 'session-timeout';
      };

      this.showWarning = () => {
        warningModal = $modal({
          backdrop: 'static',
          scope: $scope,
          template: 'ui-ng-session-timer/dist/components/user_session_timeout_modal/user_session_timer_modal.html',
          show: false,
          placement: 'center'
        });
        warningModal.$promise.then(warningModal.show);
        this.modal.isModalVisible = true;
      };

      this.onTick = (count) => {
        if (count < WAIT_TIME_DEFAULT && !this.modal.isModalVisible) {
          this.showWarning();
        }
        this.countDown = count;
      };

      this.warningCallBack = () => {
        if (this.modal.isModalVisible) {
          this.logout();
          phxNotificationDelegate.restrictTo(this.notificationHandle).warn({
            content: 'You were logged out because of inactivity.',
            dismissOnTimeout: false,
            name: 'session-logged-out-warning'
          });
        }
      };

      this.logout = () => {
        logoutCommand().then(() => {
          this.modal.isModalVisible = false;
          warningModal.hide();
        });
      };

      this.keepWorking = () => {
        extendSessionCommand()
          .then(() => {
            sessionTimerDelegate.restartSession();
            this.modal.isModalVisible = false;
            warningModal.hide();
          })
          .catch(() => {
            this.warningCallBack();
          });
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/components/user_session_timeout_modal/user_session_timeout.es.js